module.exports = __webpack_public_path__ + "src/assets/images/volums/wind_speed/volum_circle2.png?cba07a0ac1c371efd5cf4e6d07fd2b97";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/volums/wind_speed/volum_circle2.png
// module id = 805
// module chunks = 0